import React, { useState } from "react";
import { XIcon, ExclamationIcon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";

export default function TimeZoneAlert() {
  const { t } = useTranslation();
  const [show, setShow] = useState(true);
  if (!show) return <></>;
  return (
    <div className="p-4 rounded-md bg-yellow-50">
      <div className="flex">
        <div className="flex-shrink-0">
          <ExclamationIcon
            aria-hidden="true"
            className="w-5 h-5 text-yellow-400"
          />
        </div>
        <div className="ltr:ml-3 rtl:mr-3">
          <p className="text-sm font-medium text-yellow-800">
            {t("timeZoneAlert")}
          </p>
        </div>
        <div className="ltr:ml-auto rtl:mr-auto ltr:pl-3 rtl:pr-3">
          <div className="-mx-1.5 -my-1.5">
            <button
              onClick={() => setShow(false)}
              type="button"
              className="inline-flex rounded-md bg-yellow-50 p-1.5 text-yellow-500 hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-yellow-600 focus:ring-offset-2 focus:ring-offset-yellow-50"
            >
              <span className="sr-only">Dismiss</span>
              <XIcon aria-hidden="true" className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
